import { createActionGroup, props } from '@ngrx/store';

import { SafeAny } from '../../types/safe-any';
import { ApiErrorType } from '../app.actions';

import { Client, ClientPayload, Country, State } from './clients.state.interface';

export const ClientsApiActions = createActionGroup({
  source: 'ClientsApi',
  events: {
    // Load Clients
    'Load Clients': props<{
      payload: SafeAny;
    }>(),
    'Load Clients Success': props<{
      clients: Client[];
      totalCount: number;
    }>(),
    'Load Clients Error': props<{
      error: ApiErrorType;
    }>(),

    // Add Client
    'Add Client': props<{
      payload: ClientPayload;
    }>(),
    'Add Client Success': props<{
      client: Client;
    }>(),
    'Add Client Error': props<{
      error: ApiErrorType;
    }>(),

    // Load Specific Client
    'Load Client': props<{
      clientId: string;
    }>(),
    'Load Client Success': props<{
      client: Client;
    }>(),
    'Load Client Error': props<{
      error: ApiErrorType;
    }>(),

    // Update Client
    'Update Client': props<{
      payload: ClientPayload;
      clientId: string;
    }>(),
    'Update Client Success': props<{
      client: Client;
    }>(),
    'Update Client Error': props<{
      error: ApiErrorType;
    }>(),

    // Duplicate Client
    'Duplicate Client': props<{
      clientId: string;
    }>(),
    'Duplicate Client Success': props<{
      client: Client;
    }>(),
    'Duplicate Client Error': props<{
      error: ApiErrorType;
    }>(),

    // Load Countries
    'Load Countries': props<{
      payload: SafeAny;
    }>(),
    'Load Countries Success': props<{
      countries: Country[];
    }>(),
    'Load Countries Error': props<{
      error: ApiErrorType;
    }>(),

    // Load States
    'Load States For Address 1': props<{
      payload: SafeAny;
    }>(),
    'Load States For Address 1 Success': props<{
      states: State[];
    }>(),
    'Load States For Address 1 Error': props<{
      error: ApiErrorType;
    }>(),

    // Load States For Address 2
    'Load States For Address 2': props<{
      payload: SafeAny;
    }>(),
    'Load States For Address 2 Success': props<{
      states: State[];
    }>(),
    'Load States For Address 2 Error': props<{
      error: ApiErrorType;
    }>(),
  },
});
